import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const liveProducts = [
    {
      name: 'BaciCheck',
      url: 'https://bacicheck.bacimo.net',
      description: 'Live product for accessibility compliance workflows',
    },
    {
      name: 'BacimOCR',
      url: 'https://bacimocr.bacimo.net',
      description: 'Live product for practical document OCR workflows',
    },
  ];

  const secondaryProduct = {
    name: 'BaciScout',
    url: 'https://baciscout.bacimo.net',
    description: 'Secondary BACIMO product in development for tender intelligence workflows.',
    status: 'In development',
  };

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-brand">
          <Link to="/" className="footer-logo-link" aria-label="BACIMO - Home">
            <img 
              src="/logo_trans.png" 
              alt="" 
              className="footer-logo-img"
              aria-hidden="true"
            />
            <span className="visually-hidden">BACIMO</span>
          </Link>
          <p className="footer-tagline">BACIMO builds practical AI products for document, compliance, and workflow clarity.</p>
          <p className="footer-note">Live now: BaciCheck and BacimOCR. Thoughtful product pilots and partner conversations welcome.</p>
        </div>

        <nav className="footer-links" aria-label="Products">
          <div className="footer-product-group">
            <h2 id="footer-live-products-heading">Live products</h2>
            <ul aria-labelledby="footer-live-products-heading">
              {liveProducts.map((product) => (
                <li key={product.name}>
                  <a 
                    href={product.url}
                    aria-label={`${product.name} - ${product.description}`}
                  >
                    <span className="footer-product-name">{product.name}</span>
                    <span className="footer-product-status footer-product-status-live">
                      Live
                    </span>
                  </a>
                  <p>{product.description}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-product-group footer-product-group-secondary">
            <h2 id="footer-in-development-heading">In development</h2>
            <ul aria-labelledby="footer-in-development-heading">
              <li key={secondaryProduct.name}>
                <a 
                  href={secondaryProduct.url}
                  aria-label={`${secondaryProduct.name} - ${secondaryProduct.description}`}
                >
                  <span className="footer-product-name">{secondaryProduct.name}</span>
                  <span className="footer-product-status footer-product-status-in-development">
                    {secondaryProduct.status}
                  </span>
                </a>
                <p>{secondaryProduct.description}</p>
              </li>
            </ul>
          </div>
        </nav>

        <div className="footer-contact">
          <h2 id="footer-contact-heading">Contact</h2>
          <p>For pilot access, partnerships, and product feedback.</p>
          <a href="mailto:info@bacimo.net">
            info@bacimo.net
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} Bacimo s.r.o. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
